import * as React from 'react';
import { IShipOverviewPageMobileCompany } from '../../../reducers/shipOverview';
import RecommendationSection from '../../../components/Recommendation/RecommendationSection';
import { shipList } from '../../../components/Recommendation/shipList';

interface StateProps {
    company: IShipOverviewPageMobileCompany;
    currency: string;
}

interface DispatchProps {
    fetchShipPrices: Function;
}

type Props = StateProps & DispatchProps;

export class CompanyRecommendations extends React.Component<Props, any> {
    componentDidMount() {
        this.props.fetchShipPrices(this.props.company.nid);
    }

    render() {
        const { ships } = this.props.company;
        const lazyShipListProps = {
            ships,
            currency: this.props.currency,
        };

        return <RecommendationSection data={shipList(lazyShipListProps)} collapsibleComponent />;
    }
}
